import { BAILocale } from '.';
import zh_CN from 'antd/es/locale/zh_CN';

const localeValue: BAILocale = {
  lang: 'zh-CN',
  antdLocale: zh_CN,
};

export default localeValue;
